import { render } from "./BillingPage.vue?vue&type=template&id=952c2e92&scoped=true"
import script from "./BillingPage.vue?vue&type=script&lang=js"
export * from "./BillingPage.vue?vue&type=script&lang=js"

import "./BillingPage.vue?vue&type=style&index=0&id=952c2e92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-952c2e92"]])

export default __exports__